import { g as getNamespacedTagFor } from './index-739b155e.js';

const supportedDropdownTriggers = Object.freeze([
  getNamespacedTagFor('market-button'),
  getNamespacedTagFor('market-link'),
  getNamespacedTagFor('market-filter-button'),
]);

export { supportedDropdownTriggers as s };
